import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';

const DEFAULT_RATIOS = [1, 4 / 5, 3 / 4]; // Default accepted aspect ratios
const AdaptiveAspectImage = ({
  src,
  alt = '',
  ratios = DEFAULT_RATIOS, // accepted aspect ratios
  objectFit = 'contain', // CSS object-fit value
  objectPosition, // CSS object-position value
  className = '',
  testId,
}) => {
  const [chosenRatio, setChosenRatio] = useState(null);
  const [naturalSize, setNaturalSize] = useState(null);

  useEffect(() => {
    const img = new Image();
    img.src = src;
    img.onload = () => {
      const {naturalWidth, naturalHeight} = img;
      const naturalRatio = naturalWidth / naturalHeight;

      // Find the ratio with the smallest absolute difference
      const closest = ratios.reduce(
        (acc, ratio) => {
          const diff = Math.abs(naturalRatio - ratio);
          if (diff < acc.diff) {
            return {ratio, diff};
          }
          return acc;
        },
        {ratio: null, diff: Infinity},
      );

      setChosenRatio(closest.ratio);
      setNaturalSize({width: naturalWidth, height: naturalHeight});
    };
  }, [src, ratios]);

  const containerStyle = {
    aspectRatio: chosenRatio ? `${chosenRatio}` : 'auto',
  };

  return (
    <div className="adaptive-aspect-image__container" style={containerStyle} data-testid={testId}>
      {naturalSize && (
        <img
          className={[
            'adaptive-aspect-image__img',
            objectFit && 'adaptive-aspect-image__img--' + objectFit,
            objectPosition && 'adaptive-aspect-image__img--' + objectPosition,
            className,
          ]
            .filter(Boolean)
            .join(' ')}
          src={src}
          alt={alt}
          width={naturalSize.width}
          height={naturalSize.height}
        />
      )}
    </div>
  );
};

AdaptiveAspectImage.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string,
  ratios: PropTypes.arrayOf(PropTypes.number),
  objectFit: PropTypes.oneOf(['fill', 'contain', 'cover']),
  objectPosition: PropTypes.string,
  className: PropTypes.string,
  testId: PropTypes.string,
};

export default AdaptiveAspectImage;
